import React, { useMemo } from "react";
import Text from "../text";
import { head, size, map } from "lodash";
import { Separator, EmptyResult, CardContainer } from "./styled-components";
import SituationCard from "../situationCard";
import { useNavigate } from "react-router-dom";

const ResultBloc = ({ results, searchedValue }: SearchBlocProps) => {
  const navigate = useNavigate();

  const hasResults = useMemo(() => head(results), [results]);

  const getTitle = () => {
    if (size(results) <= 1) {
      return `${size(results)} situation trouvée pour “${searchedValue}”`;
    }
    if (size(results) > 1) {
      return `${size(results)} situations trouvées pour “${searchedValue}”`;
    }
  };

  const handleNavigation = (result: any) => {
    if (result.domain === "alerte") {
      if (result.url.toLowerCase() !== "je souhaite lancer une alerte") {
        navigate(`/${result.domain}/${result.url.toLowerCase()}/orientation`);
      } else {
        navigate(
          `/${result.domain}/${
            result.title
          }/${result.thematique.toLowerCase()}/${result.theme.id}`
        );
      }
    } else {
      if (result.preProcedure === true) {
        navigate(`/${result.domain}/demarches/${result.url.toLowerCase()}`);
      } else {
        navigate(`/${result.domain}/${result.url.toLowerCase()}`);
      }
    }
  };

  return (
    <div>
      <Text size="24px" weight={600} color="grey500">
        {getTitle()}
      </Text>
      <Separator />
      {hasResults ? (
        <CardContainer>
          {map(results, (result, index) => {
            return (
              <SituationCard
                key={index}
                title={result.title}
                description={result.description}
                color="grey"
                onClick={() => handleNavigation(result)}
              />
            );
          })}
        </CardContainer>
      ) : (
        <EmptyResult>
          <Text weight={600}>Votre recherche n'a donné aucun résultat</Text>
          <ul>
            <li>Vérifier l’orthographe de votre recherche</li>
            <li>Essayer avec d’autres mots-clés</li>
            <li>
              Appeler le <a href="tel:0969390000">09 69 39 00 00</a> pour avoir
              plus de renseignements
            </li>
            <li>
              <a href="/">Revenir à l’accueil</a>
            </li>
          </ul>
        </EmptyResult>
      )}
    </div>
  );
};

export default ResultBloc;
